// hooks/useCopyProjectData.js

import { useState } from 'react';
import appConfig from '../../config/appConfig';

export const useCopyProjectData = (loginToken) => {
  const [isLoading, setIsLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [copyResults, setCopyResults] = useState(null);
  const [error, setError] = useState(null);

  const fetchProjects = async (corporateAccount) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(appConfig.getUrl('/get_project_list'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${loginToken}`
        },
        body: JSON.stringify({ corporate_account: corporateAccount }),
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch projects');
      }
      
      const data = await response.json();
      if (data.status === 'Success') {
        setProjects(data.project_list || []);
      } else {
        throw new Error(data.status_description || 'Failed to fetch projects');
      }
    } catch (err) {
      setError(err.message);
      setProjects([]);
    } finally {
      setIsLoading(false);
    }
  };

  const copyProjectData = async (copyRequest) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(appConfig.getUrl('/copy_project_records'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${loginToken}`
        },
        body: JSON.stringify(copyRequest),
      });
      
      if (!response.ok) {
        throw new Error('Failed to copy project data');
      }
      
      const data = await response.json();
      setCopyResults(data);
      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const resetState = () => {
    setCopyResults(null);
    setError(null);
    setProjects([]);
  };

  return {
    isLoading,
    projects,
    copyResults,
    error,
    fetchProjects,
    copyProjectData,
    resetState,
  };
};